import React from 'react';
import { Card, CardBody, Container } from 'reactstrap';

const styles = {
  appViewContainer: {
    padding: 0,
    backgroundColor: '#e6f7ff',
    paddingBottom: '20px',
  },
  mainContent: {
    margin: '0 auto',
    minHeight: 'calc(100vh - 20px)',
  },
};

const TermsCondition = () => {
  return (
    <div style={styles.appViewContainer}>
      <Container style={styles.mainContent} className="justify-content-center align-items-center ">
        <div className="logo-icon text-center">
          <img src="content/images/cases/dyhaclogo.svg" alt="Logo" className="logo-img" />
        </div>
        <Card className="terms-card">
          <CardBody>
            <div className="title-section">
              <h4>Terms of Use</h4>
              <p>
                <strong>Last updated: [February 25, 2025]</strong>
              </p>
            </div>
            <div className="scrollable-terms">
              <p className="main-title">PLEASE READ THESE TERMS AND CONDITIONS OF USE CAREFULLY BEFORE USING THIS SITE.</p>
              <p>You are visiting a website owned by LifeSolutions Technology LLC ("we" or "us"), an Arizona company.</p>
              <p>
                This Terms of Use Agreement (“Agreement”) applies to all websites owned or operated by LifeSolutions Technology LLC and its
                affiliates and subsidiaries (“Websites” or each individually “Website”), including Do You Have a Case (“DYHAC”), on which
                this Agreement or a link to this Agreement is displayed.
              </p>
              <p>
                This Agreement also applies to your use of any goods, facilities, or services offered through the Websites (collectively,
                “Services”), regardless of how they are accessed, including but not limited to via a desktop computer or mobile device.
              </p>

              <div className="list-style">
                <h5>Definitions</h5>
                <ul>
                  <li>
                    “You” or “your” refers to the person(s) using the Websites and/or Services, including any person(s) for whom such
                    person(s) act as an agent.
                  </li>
                  <li>
                    “LifeSolutions Technology LLC,” “us,” “our,” or “we” includes LifeSolutions Technology LLC and any of its affiliates or
                    subsidiaries.
                  </li>
                  <li>“Legal AI Solutions” includes Legal AI Solutions and any of its affiliates or subsidiaries.</li>
                </ul>
              </div>
              <div className="list-style">
                <h5> Modification of Terms</h5>
                <ul>
                  <li>
                    {' '}
                    We reserve the right, in our sole discretion, to change or modify this Agreement and/or the Websites at any time. Any
                    changes become effective immediately upon posting on the Websites.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>Eligibility</h5>
                <ul>
                  <li>
                    The Websites and Services are intended for individuals who are at least 18 years old and accessing the internet from a
                    physical location within the United States.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>Additional Terms</h5>
                <ul>
                  <li>
                    Some Services may be subject to additional terms and conditions (“Additional Terms”), such as eligibility requirements,
                    age restrictions, or geographic limitations.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>Privacy Policy</h5>
                <ul>
                  <li>
                    Our Privacy Policy, incorporated herein by reference, explains how we collect, use, disclose, and protect your
                    information in connection with the Services.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>Ownership Rights</h5>
                <ul>
                  <li>
                    All text, graphics, photographs, videos, sound, trademarks, logos, artwork, interfaces, data, and computer code
                    (collectively, “Content”) displayed on or made available through the Websites are owned or licensed by or to
                    LifeSolutions Technology LLC.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>Code of Conduct</h5>
                <ul>
                  <li>
                    You are solely responsible for your conduct in connection with the Services. You must not violate any applicable law,
                    disrupt the operation of the Websites, or engage in unauthorized data scraping.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>Chatbots</h5>
                <ul>
                  <li>
                    By using our chatbot, you acknowledge that it may use machine learning and AI and that chatbot responses may not always
                    be accurate.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5> Links to Third-Party Websites</h5>
                <ul>
                  <li>
                    The Websites may contain links to external sites (“Third Party Sites”) for your convenience. We do not control or
                    endorse any Third Party Site.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5> Disclaimers & Limitation of Liability</h5>
                <ul>
                  <li>
                    The Websites, Content, and Services are provided “as is” and “as available.” We do not warrant that our Websites will be
                    error-free or uninterrupted.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5> Indemnity</h5>
                <ul>
                  <li>
                    You agree to indemnify and hold harmless LifeSolutions Technology LLC, its affiliates, officers, directors, and
                    employees from any claims arising from your use of the Websites or Services.
                  </li>
                </ul>
              </div>
              <div className="list-style">
                <h5>Governing Law</h5>
                <ul>
                  <li>This Agreement is governed by the laws of the State of California, without regard to conflict of laws principles.</li>
                </ul>
              </div>
            </div>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default TermsCondition;
